import {TokenBody} from '../modules/shared/model/token-body';
import { Injectable } from "@angular/core";

@Injectable()
export class TokenService {

  private token: TokenBody;

  public init(encodedToken: string) {
    this.token = this.decodeToken(encodedToken);
  }

  public getLoginId(): string {
    return this.token.LoginId.toString();
  }

  public getExp(): number {
    return this.token.exp;
  }

  public getUsername(): string {
    return this.token.Username;
  }

  public getFirstName(): string {
    return this.token.FirstName;
  }

  public getLastName(): string {
    return this.token.LastName;
  }

  public getCulture(): string {
    return (this.token != null && this.token.Culture != null) ? this.token.Culture : null;
  }

  public getCountry(): string {
    return this.token.Country;
  }

  private decodeToken(encodedToken: string): TokenBody {
    if (encodedToken != null) {
      const tokenParts: string[] = encodedToken.split('.');
      if (tokenParts[1] != null) {
        const decodedTokenJson = decodeURIComponent(Array.prototype.map.call(atob(tokenParts[1]), function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(decodedTokenJson);
      }
    }
    return null;
  }
}
